<div class="table-outer table-theme">
  <div class="table-responsive h-100">
    <p-table
      [className]="'table-prime'"
      [value]="specLots()"
      dataKey="id"
      [scrollable]="true"
      [rowHover]="true"
      styleClass="p-datatable-striped"
    >
      <ng-template #header>
        <tr>
          <th>Unit No.</th>
          <th>Phase</th>
          <th>Type</th>
          <th>Status</th>
          <th>Address</th>
          <th>Model/Elev</th>
          <th>Release Date</th>
          <th>Reserve Exp.</th>
          <th>Builder</th>
          <th>Legal Unit No</th>
        </tr>
      </ng-template>
      <ng-template #body let-specLot>
        <tr
          class="cursor-pointer"
          (click)="onRowClick(specLot)"
          role="button"
          tabindex="0"
          (keydown.enter)="onRowClick(specLot)"
          (keydown.space)="onRowClick(specLot)"
        >
          <td>{{ specLot.lotNo }}</td>
          <td>-</td>
          <td>{{ specLot.lotTypeName }}</td>
          <td>{{ specLot.statusName || '-' }}</td>
          <td>
            @if (specLot.address) {
              {{ specLot.address.streetNo }} {{ specLot.address.street }}
              @if (specLot.address.street2) {
                {{ specLot.address.street2 }}
              }
            } @else {
              -
            }
          </td>
          <td>
            @if (specLot.selectedModel) {
              {{ specLot.selectedModel.modelName }}
              @if (specLot.selectedElevation) {
                ({{ specLot.selectedElevation.elevationCode }})
              }
            } @else if (specLot.models && specLot.models.length > 0) {
              {{ specLot.models[0].modelName }}
            } @else {
              -
            }
          </td>
          <td>
            @if (specLot.finalSaleDate) {
              {{ specLot.finalSaleDate | date: 'short' }}
            } @else {
              -
            }
          </td>
          <td>-</td>
          <td>-</td>
          <td>{{ specLot.legalUnit || '-' }}</td>
        </tr>
      </ng-template>
    </p-table>
  </div>
</div>
